import React, { useState, useEffect } from "react";
import { GetMyOrders } from "../Api/services/orderServices";
import Loader from "../component/common/Loader"
import Navbar from "../component/NavBar"
import Footer from "../component/Footer"

const MyOrder = () => {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        fetchOrders();
    }, []);

    const fetchOrders = async () => {
        const token = localStorage.getItem("token");
        setLoading(true);
        try {
            const response = await GetMyOrders(token);
            console.log(response.data);
            setOrders(response.data);
        } catch (err) {
            console.log(err.message);
        } finally {
            setLoading(false);
        }

    };

    if (loading) return <div className="min-h-screen flex items-center justify-center"><Loader /></div>;

    return (
        <div className="min-h-screen flex flex-col">
            <Navbar />
            <div className="flex-grow bg-gray-50">
                <div className="max-w-7xl mx-auto px-4 py-8 sm:px-6 lg:px-8">
                    <h1 className="text-3xl font-bold text-gray-900 mb-8 text-center">My Orders</h1>

                    {orders?.length === 0 ? (
                        <div className="text-center py-12 min-h-screen md:min-h-0">
                            <p className="text-2xl text-gray-600 mb-4">No orders found</p>
                            <button
                                onClick={() => window.location.href = '/shop'}
                                className="inline-block px-6 py-3 bg-red-500 text-white rounded-md hover:bg-red-600 transition-colors"
                            >
                                Continue Shopping
                            </button>
                        </div>
                    ) : (
                        <div className="grid gap-8 grid-cols-1">
                            {orders?.sort((a, b) => new Date(b?.createdAt) - new Date(a?.createdAt))?.map((order, index) => (
                                <div
                                    key={index}
                                    className="bg-white rounded-lg shadow-sm p-4"
                                >
                                    <div className="flex justify-between items-center mb-4">
                                        <div>
                                            <h3 className="text-lg font-medium">Order details</h3>
                                            <p className="text-gray-600 text-sm">Order Id: {order?.razorpayOrderId}</p>
                                            <p className="text-gray-600 text-sm">Order On: {new Date(order?.createdAt).toLocaleString()}</p>
                                        </div>
                                        <span className={`text-lg ${order?.status === "Cancelled" ? " bg-red-600 text-gray-100" : "bg-green-600 text-gray-100"} px-2 py-1 rounded-md`}>{order?.status}</span>
                                    </div>

                                    {order?.items?.map((item) => (
                                        <div
                                            key={item?.id}
                                            className="flex items-center gap-4 py-4 border-t"
                                        >
                                            <img
                                                src={item?.productId?.images[0]}
                                                alt={item?.productId?.title}
                                                className="w-16 h-16 rounded-md object-cover"
                                            />
                                            <div className="flex-grow">
                                                <h4 className="font-medium">{item?.productId?.title}</h4>
                                                <h6 className="font-small">Size:{item?.size}</h6>
                                            </div>

                                            <div className="text-right">
                                                <p className="font-medium">₹{item?.productId?.discountedPrice}</p>
                                                <p className="text-gray-600">x {item?.quantity}</p>
                                            </div>
                                        </div>
                                    ))}

                                    <div className="border-t mt-4 pt-4 space-y-2">
                                        <div className="flex justify-between text-sm">
                                            <span>Total quantity</span>
                                            <span>{order?.items?.reduce((acc, item) => acc + item?.quantity, 0)}</span>
                                        </div>
                                        <div className="flex justify-between text-sm">
                                            <span>Items Subtotal</span>
                                            <span>₹{order?.totalAmount}</span>
                                        </div>

                                        <div className="flex justify-between text-sm">
                                            <span>Shipping</span>
                                            <span>+₹0</span>
                                        </div>
                                        <div className="flex justify-between font-medium pt-2 border-t">
                                            <span>Total:</span>
                                            <span>₹{order?.totalAmount}</span>
                                        </div>
                                    </div>

                                    <div className="mt-6">
                                        <h4 className="font-medium mb-2">Shipping Information</h4>
                                        <div className="space-y-1 text-sm">
                                            <p><span className="text-gray-600">Name:</span> {order?.customerName}</p>
                                            <p><span className="text-gray-600">Phone:</span> {order?.phoneNumber}</p>
                                            <p><span className="text-gray-600">Address:</span> {`${order?.shippingAddress?.state}, ${order?.shippingAddress?.city}, ${order?.shippingAddress?.pinCode}`}</p>
                                        </div>
                                        <p className="text-sm mt-4">It is estimated to be delivered by {new Date(order?.createdAt).toLocaleDateString()}</p>
                                    </div>

                                    <div className="flex gap-4 mt-6">
                                        <button className="flex-1 py-2 px-4 border rounded-full text-center">Cancel</button>
                                        <button className="flex-1 py-2 px-4 border rounded-full text-center">Logistics Tracking</button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default MyOrder;
